import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineCornerDownRightAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M20.92 12.62a1.0002 1.0002 0 0 0-.21-.33l-3-3a1.0041 1.0041 0 0 0-1.42 1.42l1.3 1.29H8a1.0002 1.0002 0 0 1-1-1V7a1 1 0 0 0-2 0v4a3 3 0 0 0 3 3h9.59l-1.3 1.29a.9997.9997 0 0 0 0 1.42.9997.9997 0 0 0 1.42 0l3-3a1.0002 1.0002 0 0 0 .21-.33c.1-.2435.1-.5165 0-.76Z"/>
  </SvgIcon>
}

export default LineCornerDownRightAltIcon
